<h4 class="mb-15">Notification Settings</h4>
<div class="rte mb-30">
  <p class="font-16">Learn about new products or features and receive updates on your policies, claims and quotes.</p>
</div>
<table class="table table--inputs mb-0">
  <thead>
    <tr>
      <th>Notifications</th>
      @for (com of comTypes; track com) {
        <th class="cell-50 cell-centered">{{com?.comms_type}}</th>
      }
      <!--<th class="cell-50 cell-centered">Email</th>-->
    </tr>
  </thead>
  <tbody>
    @for (notification of notifications; track notification) {
      @if (notification?.comTypesParsed?.length) {
        <tr>
          <td>
            <h6 class="font-16">{{notification?.notification_type}}</h6>
            <p>{{notification?.notification_description}}</p>
          </td>
          @for (com of comTypes; track com) {
            <td class="cell-50 cell-centered">
              <label class="custom-input custom-input--checkbox custom-input--naked">
                <input
                  type="checkbox"
                  [checked]="checkNotificationChecked(com, notification)" [name]="notification?.notification_type + '-' + com?.comms_type_id"
                  (change)="onNotificationChecked(com, notification, $event)">
                  <span class="custom-input__indi"></span>
                </label>
              </td>
            }
          </tr>
        }
      }
    </tbody>
  </table>
